import { useCallback, useContext, useState } from "react";
import { ThemeType } from "@markit/common.types";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import { useTheme } from "../../hooks/useTheme";
import PaymentFailedButtonModal from "../DisplayModal/UpdatePaymentInfoModal";
import { MixpanelContext } from "../../context/AnalyticsService";

interface NoticeBannerProps {
  eventTheme?: ThemeType;
}

// TODO (jonathan): in app also uses this to display free tier overflow, add that in future
const NoticeBanner = ({ eventTheme }: NoticeBannerProps) => {
  const { theme } = useTheme(eventTheme);
  const mixpanel = useContext(MixpanelContext);

  const [paymentFailedVisible, setPaymentFailedVisible] = useState(false);

  const onPress = useCallback(() => {
    mixpanel.track("Pressed Update Payment Info Button");
    setPaymentFailedVisible(true);
  }, [mixpanel]);

  return (
    <>
      {paymentFailedVisible ? (
        <PaymentFailedButtonModal
          isVisible={paymentFailedVisible}
          setIsVisible={setPaymentFailedVisible}
          location="Texting Panel Usage"
        />
      ) : null}
      <div
        className="AlignedRowSelect"
        onClick={onPress}
        style={{
          paddingInline: 12,
          paddingBlock: 8,
          borderRadius: 8,
          gap: 11,
          backgroundColor: "rgba(239, 68, 68, 0.1)",
          border: `1px solid ${Colors.RED3}`,
        }}
      >
        <Icon icon="ion:warning" height={19} style={{ color: Colors.RED3 }} />
        <div className="ColumnNormal" style={{ gap: 2 }}>
          <span
            className="bodyMedium"
            style={{ color: theme.PrimaryText.color }}
          >
            Update Billing
          </span>
          <span className="smallBodySubtext">to access Markit+</span>
        </div>
      </div>
    </>
  );
};

export default NoticeBanner;
